<template>
    <div>
        <NavSolutionBlock
            v-for="activeSolution in activeSolutions"
            v-bind:activeSolution="activeSolution"
        />
    </div>
</template>

<script>
    import NavSolutionBlock from '@/components/NavSolutionBlock.vue'

    export default {
        name: "NavSolutionsList",
        props: ['activeSolutions'],
        data() {
            return {}
        },
        watch:{
            'activeSolutions'(){
            }
        },
        components:{
            NavSolutionBlock
        },
    }
</script>

<style lang="scss" scoped>

</style>